import * as API from './api'
import * as Types from './Types'

export function tryCreateBooking(token, apartmentId, communityId, data) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_BOOKING,
      payload: data
    })

    API.createBooking(token, apartmentId, communityId, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_BOOKING_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.CREATE_BOOKING_FAILED,
          payload: { status, data }
        })
      })
  }
}

export function tryDeleteBooking(token, apartmentId, communityId, bookingId) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_BOOKING,
      payload: bookingId
    })

    API.deleteBooking(token, apartmentId, communityId, bookingId)
      .then(() => {
        dispatch({
          type: Types.DELETE_BOOKING_SUCCESS,
          payload: { bookingId, communityId, apartmentId }
        })
      })
      .catch(error => {
        dispatch({
          type: Types.DELETE_BOOKING_FAILED,
          payload: bookingId
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/LaundryBookings.js